import React, {Component} from 'react'
import PropTypes from 'prop-types'
import openseadragon from 'openseadragon'
import 'svg-overlay'
import { select, selectAll } from 'd3-selection'
import {
  fetchImage
} from '../Helpers.js'

const d3 = Object.assign(
  {},
  {
    select,
    selectAll
  }
)

export default class OpenSeaDragon extends Component {
  initSeaDragon () {
    const {
      id,
      image,
      type,
      overlays,
      defaultZoomLevel,
      minZoomLevel,
      maxZoomLevel,
      zoomPerScroll,
      onShowPage,
      onClosePage
    } = this.props

    if (image) {
      this.viewer = openseadragon({
        id: id,
        // debugMode: true,
        preload: false,
        defaultZoomLevel: defaultZoomLevel,
        minZoomLevel: minZoomLevel,
        maxZoomLevel: maxZoomLevel,
        zoomPerScroll: zoomPerScroll,
        constrainDuringPan: true,
        visibilityRatio: 1.0,
        showNavigationControl: false,
        gestureSettingsMouse: {
          dblClickToZoom: true,
          clickToZoom: false,
          pinchRotate: true
        },
        gestureSettingsTouch: {
          pinchRotate: true
        },
        tileSources: [{
          type: type,
          width: (image && image.width) || 300,
          height: (image && image.height) || 300,
          tilesUrl: (image && image.folder) || null
        }],
        blendTime: 0.5,
        immediateRender: false
      })

      const endLoad = () => {
        const tiledImage = this.viewer.world.getItemAt(0)
        if (tiledImage.getFullyLoaded()) {
          this.props.onEndLoading()
          tiledImage.removeHandler('fully-loaded-change', endLoad)
        }
      }

      this.viewer.addHandler('open', () => {
        const tiledImage = this.viewer.world.getItemAt(0)
        tiledImage.addHandler('fully-loaded-change', endLoad)
      })

      this.svgOverlay = this.viewer.svgOverlay()
      this.overlay = d3.select(this.svgOverlay.node())

      let isMouseMove = false
      let lastClicked = null

      this.viewer.addHandler('canvas-drag', (e) => {
        isMouseMove = true
      })

      this.viewer.addHandler('canvas-press', (e) => {
        isMouseMove = false
        if (e.originalEvent.target.dataset.page) {
          if (e.originalEvent.target.dataset.page !== lastClicked) {
            if (!this.props.isPageShowing === true) {
              onClosePage()
            }
          }
        } else if (e.originalEvent.target.dataset.linkurl) {
          onClosePage()
        } else {
          onClosePage()
        }
      })

      this.viewer.addHandler('canvas-release', (e) => {
        if (isMouseMove) {
          onClosePage()
        } else {
          if (e.originalEvent.target.dataset.page) {
            if (this.props.isPageShowing === true) {
              if (e.originalEvent.target.dataset.page !== lastClicked) {
                onShowPage(e.originalEvent.target.dataset.page, true)
              }
            } else {
              onShowPage(e.originalEvent.target.dataset.page, false)
            }
          } else if (e.originalEvent.target.dataset.linkurl) {
            window.open(e.originalEvent.target.dataset.linkurl, '_blank')
          }
        }
        lastClicked = e.originalEvent.target.dataset.page || null
      })
      // coordinates: [http://openseadragon.github.io/examples/viewport-coordinates/]
      // ratio defines the max y of the viewer
      // x is always 1
      const ratio = image && image.height !== null && image.width !== null ? image.height / image.width : 1
      const maxX = 12
      const maxY = 6

      let oW = 0.1
      let oH = 0.1
      let x = 0
      let y = 0
      let adjX = 0
      let adjY = 0

      if (overlays) {
        overlays.forEach((overlay) => {
          // The base image width relative to the viewer's width
          oW = overlay.w * 0.01

          // The base image height is measured relative to the ratio
          // the width of the viewer is always 1,
          // whereas the height could be 0.3, 0.5, 1.3 etc.
          oH = oW / overlay.ratio

          // Translating to viewer coordinates
          x = overlay.x / maxX // decimalAdjust('round', overlay.x / maxX)
          y = (overlay.y / maxY) * ratio // decimalAdjust('round', overlay.y / maxY) * ratio

          // Computing ddjustments to account for viewer boundaries
          if (overlay.x === maxX * 0.5) {
            adjX = -(oW * 0.5)
          } else if (overlay.x > (maxX * 0.5) + (oW * 0.5)) {
            adjX = -oW
          }
          if (overlay.y === maxY * 0.5) {
            adjY = -(oH * 0.5)
          } else if (overlay.y > (maxY * 0.5) + (oH * 0.5)) {
            adjY = -oH
          }

          const obj = this.overlay.append('svg:image')
            .attr('x', x + adjX)
            .attr('y', y + adjY)
            .attr('width', oW)
            .attr('height', oH)
            .attr('xlink:href', 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII=')

          let baseUrl = null
          let activeUrl = null

          if (overlay.page) {
            obj.attr('data-page', overlay.page)
          } else if (overlay.linkurl) {
            obj.attr('data-linkurl', overlay.linkurl)
          }
          fetchImage(overlay.image)
            // Appending the overlay
            .then((blob) => {
              baseUrl = window.URL.createObjectURL(blob)
              obj.attr('xlink:href', baseUrl)
            })
          fetchImage(overlay.imageactive)
            .then((blob) => {
              activeUrl = window.URL.createObjectURL(blob)
              obj
                .on('pointerover', () => {
                  obj.attr('xlink:href', activeUrl)
                })
                .on('pointerout', () => {
                  obj.attr('xlink:href', baseUrl)
                })
            })
        })
      }
    }
  }
  componentDidMount () {
    this.initSeaDragon()
  }
  shouldComponentUpdate (nextProps, nextState) {
    return false
  }
  render () {
    const {
      className,
      id
    } = this.props

    return (
      <div id={id} className={className + ' mapcontainer'}>
      </div>
    )
  }
}

OpenSeaDragon.defaultProps = {
  id: 'ocd-viewer',
  className: 'openseadragon',
  type: 'zoomifytileservice',
  minZoomLevel: 1.0,
  zoomPerScroll: 1.1,
  maxZoomLevel: 30.0,
  defaultZoomLevel: 4.0,
  isPageShowing: false
}

OpenSeaDragon.propTypes = {
  className: PropTypes.string,
  id: PropTypes.string,
  type: PropTypes.string,
  image: PropTypes.object,
  overlays: PropTypes.array,
  zoomPerScroll: PropTypes.number,
  defaultZoomLevel: PropTypes.number,
  minZoomLevel: PropTypes.number,
  maxZoomLevel: PropTypes.number,
  onShowPage: PropTypes.func,
  onClosePage: PropTypes.func,
  onEndLoading: PropTypes.func,
  isPageShowing: PropTypes.bool
}
